import React, {useEffect, useState, useRef} from 'react';
import ProtectedRoute from '../../routes/protected';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import performanceService from '../../services/data/performance.service';
import moment from "moment";
import 'moment/locale/pt-br'
import { Toast } from 'primereact/toast';
import FormCreateDevPlanQuestion from '../../components/performance/forms/formCreateDevPlanQuestion';
import FormCreateActionPlan from '../../components/performance/forms/formCreateActionPlan';
import SkeletonProcess from './skeletonProcess';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import konvivaService from '../../services/data/konviva.service';


export default function DevelopmentPlanProcess() {

    const [pageLoad, setPageLoad] = useState(true)
    
    const { id } = useParams()
    const toast = useRef(null)
    const navigate = useNavigate();
    const [object, setObject] = useState('')
    const [employee, setEmployee] = useState('')
    const [currentSession, setCurrentSession] = useState('')
    const [currentQuestion, setCurrentQuestion] = useState('')
    const modalRef = useRef()
    const modalRef2 = useRef()
    const canvaRefSend = useRef()
    const offCanvasActionPlanRef = useRef()

    // Plano de Ação
    const [currentActionPlan, setCurrentActionPlan] = useState('')
    
    useEffect(() => {

        if (id) {
            getObject()
        }
    }, [id])

    function getObject() {
        
        performanceService.getPerformanceReview(id).then((response) => {
            setObject(response)
            setEmployee(response.employees[0])
            if (response.sessions.length > 0){
                setCurrentSession(response.sessions[0])
            }
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error?.response?.data), life: 4000 });
        }).finally(() => {
            setPageLoad(false)
        })

    }

    useEffect(() => {
        if (object){
            countQuestionsAndActionPlans()
        }
    }, [object])

    // count questions and action plans
    const countQuestionsAndActionPlans = () => {
        let countQuestions = 0
        let countActionPlans = 0
        if(object && object.sessions && object.sessions.length > 0){

            let questions = object.sessions[0].questions

            if (questions && questions.length > 0){
                
                //count questions
                countQuestions = questions.length
                
                questions.forEach((question) => {
                    if (question.actionPlan && question.actionPlan.length > 0){
                        countActionPlans += 1
                    }
                })

            }
        }
        let _response = {countQuestions, countActionPlans}
        
        if (countActionPlans === countQuestions && countQuestions > 0){
            return true
        }
        return false
    }

    function deleteQuestion() {
        let data = {
            id: currentQuestion.id,
            company_id: localStorage.getItem("companyId")
        }

        performanceService.deleteAssessmentQuestion(data).then(() => {
            
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Pergunta apagada com sucesso', life: 3000 });

            setTimeout(() => {
                hideModal()
                getObject()
            }, 3000);
        })
    }

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    const hideModal2 = () => {
        const modalEl = modalRef2.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    const hideOffCanvasSend = () => {
        const elem = canvaRefSend.current
        const modal = bootstrap.Offcanvas.getInstance(elem)
        modal.hide()
    }

    const hideOffCanvasActionPlan = () => {
        const elem = offCanvasActionPlanRef.current
        const modal = bootstrap.Offcanvas.getInstance(elem)
        modal.hide()
    }

    function actionPlanType(value) {
        switch (value) {
            case 'CF':
                return 'Curso/Formação'
            case 'PR':
                return 'Projeto'
            case 'TR':
                return 'Trabalho'
            case 'TA':
                return 'Tarefa'
            case 'OU':
                return 'Outro'
        default:
            break;
    }
    }

    function sendMailStartPerformance() {

        let data = {
            company_id: localStorage.getItem("companyId"),
            id: object.nextStep.id
        }

        performanceService.messageTakePerformanceReview(data).then(() => {    
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: `Processo enviado com sucesso`, life: 5000 });
            getObject()
            // close offcanvas
            setTimeout(() => {
                hideOffCanvasSend()
            }, 3000);
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data, life: 4000 });
        });
        
    }

    function deleteActionPlan() {
        let data = {
            id: currentActionPlan.id,
            company_id: localStorage.getItem("companyId")
        }
        
        performanceService.deleteActionPlan(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Plano de Ação apagado com sucesso', life: 3000 });
            getObject()
            hideModal2()
            hideOffCanvasActionPlan()
        })
    }

    function getActionPlanStatus(value) {
        switch (value) {
            case 'NI':
                return 'Não Iniciado'
            case 'FA':
                return '1-25%'
            case 'FB':
                return '25-50%'
            case 'FC':
                return '50-75%'
            case 'FD':
                return '75-99%'
            case 'CS':
                return 'Completado'
        default:
            break;
    }
    }

    //check if has LM integration service
    const[konvivaCourses, setKonvivaCourses] = useState([])
    useEffect(() => {
        getKonvivaCourses()
    }, [])
    
    function getKonvivaCourses() {

        konvivaService.getCourses().then((response) => {
            setKonvivaCourses(response)
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error?.response?.data), life: 4000 });
        })
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <span className="fs-6 fw-bold ps-5 text-decoration-none text-white" role='button' onClick={() => navigate(-1)}>
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Plano de Desenvolvimento
    
                        </span>
                    </div>
                </div>
                <div className='p-3 mx-5'>
                {
                    pageLoad ?
                    <SkeletonProcess />
                    :
                    <React.Fragment>
                    <div className='d-flex bg-white border-clean rounded mb-2'>
                        <div className='col p-3 pb-0'>
                            <p className='fs-6 fw-bold mb-0'>Plano de Desenvolvimento de {employee?.user?.full_name}</p>
                            <p><span className='fw-bold'>Período:</span> {moment(object.start_date).format("DD/MM/YYYY")} - {moment(object.end_date).format("DD/MM/YYYY")}</p>
                            <p><span className='fw-bold'>Status:</span> <span className='badge bg-secondary rounded-pill px-3 py-2'>{object.statusDisplay}</span></p>
                        </div>
                    </div>
                    <div className='d-flex bg-white border-clean rounded-top'>
                        <div className='col p-3'>
                            <span className='fs-6 fw-bold mb-0'>{currentSession.title}</span>
                        </div>
                        <div className='col p-3'>
                        {
                            object.status === 'AT' && countQuestionsAndActionPlans() ?
                            <>
                            <button className='float-end btn btn-sm btn-success btn-rounded px-3 font1em' data-bs-toggle="offcanvas" data-bs-target="#offCanvasSend">Confirmar e Enviar</button>
                            </>
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className='d-flex bg-white border-clean rounded-bottom' style={{minHeight: '200px', paddingBottom: '200px', marginBottom: '200px'}}>
                        <div className='col-md-4 p-3'>
                            <div className='p-3 bg-light rounded'>
                                <p className='fw-bold border-bottom pb-1'>Adicionar Objetivo</p>
                                <FormCreateDevPlanQuestion assessment={id} session={currentSession.id} listItems={getObject} />
                            </div>
                        </div>
                        <div className='col p-3'>
                        {
                            currentSession.session_type === 'QE' ?
                            <>
                            {
                                currentSession.questions.length > 0 ?
                                <>
                                <p className='border-bottom pb-1 fw-bold'><span className='font110'>{currentSession.questions.length}</span> Objetivos Adicionados</p>
                                <div className='my-4'>
                                    <table className='table'>
                                        <tbody>
                                        {
                                            currentSession.questions.map((obj, idx) =>
                                            <React.Fragment key={idx}>
                                                <tr>
                                                    <td style={{width: '10px'}}>
                                                        <p className='fw-bold'>{idx+1}.</p>
                                                    </td>
                                                    <td style={{width: '80%'}}>
                                                        <div dangerouslySetInnerHTML={{__html: obj.question}}></div>
                                                        {
                                                            obj.competency ?
                                                            <>
                                                            <div className='border-clean rounded p-2 pb-0'>
                                                                <div><span className='fw-bold'>Competência:</span> {obj.competency.title}</div>
                                                            
                                                            {
                                                                obj.competency.description ?
                                                                <div className='pt-2' dangerouslySetInnerHTML={{__html: obj.competency.description}}></div>
                                                                : null
                                                            }
                                                            </div>
                                                            </> : null
                                                        }
                                                        <div className='mt-2'>
                                                            <button className='btn btn-sm btn-success' data-bs-toggle="offcanvas" data-bs-target="#offCanvasActionPlan" onClick={() => {setCurrentQuestion(obj); setCurrentActionPlan('')}}>
                                                                <FontAwesomeIcon className='text-white' icon={solid('plus')} /> Adicionar Plano de Ação
                                                            </button>
                                                        </div>
                                                        {
                                                            obj.actionPlan && obj.actionPlan.length > 0 ?
                                                            <div className='mt-2'>
                                                                <table className='table border-top border-start border-end'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Planos de Ação</th>
                                                                            <th>Tipo</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                {
                                                                    obj.actionPlan.map((plan, idx) =>
                                                                    <tr key={idx}>
                                                                        <td className='align-middle'>
                                                                            <span dangerouslySetInnerHTML={{__html: plan.action}}></span>
                                                                        </td>
                                                                        <td className='align-middle'>
                                                                            {actionPlanType(plan.actionType)}
                                                                        </td>
                                                                        <td className='text-end align-middle'>
                                                                            <div className='d-flex align-items-center justify-content-end gap-2'>
                                                                            {
                                                                                plan.actionPlanStatus && plan.actionPlanStatus.length > 0 && plan.actionPlanStatus[0].completed ?
                                                                                <>
                                                                                <FontAwesomeIcon className='text-green' icon={solid('circle-check')} /> 
                                                                                <span className='small'>{getActionPlanStatus(plan.actionPlanStatus[0].status)}</span>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                <button className='btn btn-sm rounded-circle' data-bs-toggle="offcanvas" data-bs-target="#offCanvasActionPlan" onClick={() => {setCurrentActionPlan(plan); setCurrentQuestion(obj)}}>
                                                                                    <FontAwesomeIcon className='text-green' icon={solid('pencil')} />
                                                                                </button>
                                                                                </>
                                                                            }
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    )
                                                                }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            : null
                                                        }
                                                    </td>
                                                    <td className='text-center'>
                                                        {
                                                            object.status === 'AT' ?
                                                            <button className='btn btn-sm rounded-circle' data-bs-toggle="offcanvas" data-bs-target="#offCanvasQuestion" onClick={() => {setCurrentQuestion(obj)}}>
                                                                <FontAwesomeIcon className='text-green' icon={solid('pencil')} />
                                                            </button>
                                                            : null
                                                        }
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                            )
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                </>
                                :
                                <p>Nenhuma pergunta adicionada ainda</p>
                            }
                            <div className='p-3'>
                            {
                                object.status === 'AT' && countQuestionsAndActionPlans() ?
                                <>
                                <button className='float-end btn btn-sm btn-success btn-rounded px-3 font1em' data-bs-toggle="offcanvas" data-bs-target="#offCanvasSend">Confirmar e Enviar</button>
                                </>
                                :
                                null
                            }
                            </div>
                            </>
                            : null
                        }
                        </div>
                    </div>
                    </React.Fragment>
                }
                </div>
            </div>
            <div className='offcanvas offcanvas-end offcanvas-size-xl' data-bs-backdrop="static" id='offCanvasQuestion' tabIndex={-1}>
                <div className='offcanvas-header'>
                    <h6 className='offcanvas-title'>Editar Pergunta</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {setCurrentQuestion('') } }></button>
                </div>
                <div className='offcanvas-body'>
                    <div className='p-3 bg-light rounded'>
                        <FormCreateDevPlanQuestion employee={employee.id} obj={currentQuestion} listItems={getObject} />
                    </div>
                    <div className="text-end btnMargin">
                        <button className="btn btn-sm font1em text-danger" data-bs-toggle="modal" data-bs-target="#formDelQues">Apagar Pergunta</button>
                    </div>
                </div>
            </div>

            <div id="formDelQues" className="modal fade" ref={modalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Apagar Pergunta</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                Tem certeza de que deseja apagar esta Pergunta?
                            </p>
                            <button className="btn btn-sm btn-danger btn-rounded px-4"  onClick={() => deleteQuestion()}>Sim, Apagar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div ref={offCanvasActionPlanRef} className='offcanvas offcanvas-end offcanvas-size-xl' data-bs-backdrop="static" id='offCanvasActionPlan' tabIndex={-1}>
                <div className='offcanvas-header'>
                    <h6 className='offcanvas-title'>Plano de Ação</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className='offcanvas-body'>
                    <div className='p-3 bg-light rounded'>
                        {
                            currentQuestion ?
                            <>
                            <div className='fw-bold'>Objetivo</div>
                            <p dangerouslySetInnerHTML={{__html: currentQuestion.question}}></p>
                            </>
                            :
                            null
                        }
                        <FormCreateActionPlan hideOffCanvas={hideOffCanvasActionPlan} actionPlan={currentActionPlan} obj={currentQuestion} employee={employee.id} listItems={getObject} konvivaCourses={konvivaCourses} />
                    </div>
                    {
                        currentActionPlan ?
                        <>
                        <div className="text-end btnMargin">
                            <button className="btn btn-sm font1em text-danger" data-bs-toggle="modal" data-bs-target="#formDelActionPlan">Apagar Plano de Ação</button>
                        </div>
                        </>
                        :
                        null
                    }
                </div>
            </div>

            <div id="formDelActionPlan" className="modal fade" ref={modalRef2}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Apagar Plano de Ação</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {
                                currentActionPlan ?
                                <>
                                <p>
                                    Tem certeza de que deseja apagar este Plano de Ação?
                                </p>
                                <button className="btn btn-sm btn-danger btn-rounded px-4" onClick={() => deleteActionPlan()}>Sim, Apagar</button>
                                </>
                                :
                                null
                            }
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className='offcanvas offcanvas-end offcanvas-size-xl' data-bs-backdrop="static" id='offCanvasSend' tabIndex={-1} ref={canvaRefSend}>
                <div className='offcanvas-header'>
                    <h6 className='offcanvas-title'>Enviar</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className='offcanvas-body'>
                    <div className='p-3 bg-light rounded'>
                        {
                            employee ?
                            <>
                            {
                                employee ?
                                <p>Tem certeza de que deseja enviar o Plano de Desenvolvimento para <span className='fw-bold'>{employee.user.full_name}</span>?</p>
                                : null
                            }
                            
                            <button className='btn btn-sm btn-success btn-rounded px-3' onClick={() => sendMailStartPerformance()} >
                                Sim, enviar
                            </button>
                            </>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}